const menu = [
    {
        icon: "coupon",
        text: "招标公告",
        class: "tender-item zab",
        toAttr: {name: 'invitationFBid', query: {title: '招标公告', type: '1', text:''}}
    },
    {
        icon: "shop",
        text: "资格预审公告",
        class: "tender-item nj",
        toAttr: {name: 'invitationFBid', query: {title: '资格预审公告', type: '2', text:''}}
    },
    {
        icon: "manager",
        text: "中标候选人公示",
        class: "tender-item zob",
        toAttr: {name: 'invitationFBid', query: {title: '中标候选人公示', type: '3', text:''}}
    },
    {
        icon: "medel",
        text: "中标结果公示",
        class: "tender-item zbj",
        toAttr: {name: 'invitationFBid', query: {title: '中标结果公示', type: '4', text:''}}
    },
    {
        icon: "label",
        text: "谈判采购公告",
        class: "tender-item tbc",
        toAttr: {name: 'invitationFBid', query: {title: '谈判采购公告', type: '5', text:''}}
    },
    {
        icon: "bill",
        text: "谈判采购拟成交结果公告",
        class: "tender-item tpc",
        toAttr: {name: 'invitationFBid', query: {title: '谈判采购拟成交结果公告', type: '6', text:''}}
    },
    {
        icon: "bell",
        text: "竞价采购公告",
        class: "tender-item jjg",
        toAttr: {name: 'invitationFBid', query: {title: '竞价采购公告', type: '7', text:''}}
    },
    {
        icon: "bag",
        text: "竞价采购拟成交结果公告",
        class: "tender-item jjc",
        toAttr: {name: 'invitationFBid', query: {title: '竞价采购拟成交结果公告', type: '8', text:''}}
    }
]

export default menu;